export enum SwapType {    
    Unknown = 0,
    Chain = 1,
    Loop = 2
}